import { render } from "./MySelector.vue?vue&type=template&id=fed4f59e"
import script from "./MySelector.vue?vue&type=script&lang=js"
export * from "./MySelector.vue?vue&type=script&lang=js"

import "./MySelector.vue?vue&type=style&index=0&id=fed4f59e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__